export default {
  listRecord: state => state.listRecord,
  callApiStatus: state => state.status
}
